import request from 'yeself-common/utils/RequestUtils';

import EnvironmentConfiguration from 'yeself-client-common/EnvironmentConfiguration';

export const fetchAuditService = (params) =>
    request.get(`${EnvironmentConfiguration.API_AUDIT_SLUG}/manage/audit`, {
        query: params,
        header: { 'Content-Type': 'application/json' },
    });
